export default __webpack_public_path__ + "static/button-anatomy-light-410e2bd2016629d17b52e95854a74702.png";